import { PointSymbolSizeType } from '@kildenshared/types/draw/point-symbol-size.type';

export const PointSymbolSizesConst: PointSymbolSizeType[] = [
  { label: '8 px', value: [8, 8], scale: 0.3 },
  { label: '12 px', value: [12, 12], scale: 0.5 },
  { label: '24 px', value: [24, 24], scale: 0.75 },
  { label: '36 px', value: [36, 36], scale: 1 },
  { label: '48 px', value: [48, 48], scale: 1.5 },
];
